import { Outlet, RouteProps } from 'react-router-dom';

export default function GovernancaLayout({ children }: RouteProps) {
	return <div>{children ?? <Outlet />}</div>;
}
